import React from "react";
import DocumentPrintPdfActions from "./DocumentPrintPdfActions";

export default function VoucherDocumentActions({ voucherId, voucherCode, label, compact = false }) {
  const safeName = (voucherCode || `voucher-${voucherId}`).replace(/[/\\?%*:|"<>]/g, "-");
  const labelKey = label ? String(label).toLowerCase() : "";
  const printTitle = label
    ? `Print ${labelKey} voucher${voucherCode ? ` (${voucherCode})` : ""}`
    : `Print voucher${voucherCode ? ` (${voucherCode})` : ""}`;
  const pdfTitle = label
    ? `Download ${labelKey} voucher PDF${voucherCode ? ` (${voucherCode})` : ""}`
    : `Download voucher PDF${voucherCode ? ` (${voucherCode})` : ""}`;

  return (
    <DocumentPrintPdfActions
      printPath={`/vouchers/${voucherId}/print`}
      pdfPath={`/vouchers/${voucherId}/pdf`}
      pdfFilename={`${safeName}.pdf`}
      groupLabel={compact ? undefined : label}
      compact={compact}
      printTitle={printTitle}
      pdfTitle={pdfTitle}
      testIdPrefix={labelKey ? `${labelKey}-voucher-${voucherCode}` : `voucher-${voucherCode}`}
      stopPropagation={compact}
    />
  );
}
